import React from 'react';
import { Button } from 'src/common/button';
import { Integration } from 'src/common/interfaces/integration.interface';
import {
  BoxIntegrationIcon,
  GongIntegrationIcon,
  GoogleChromeIntegrationIcon,
  GoogleDriveIntegrationIcon,
  HubspotIntegrationIcon,
  SegmentIntegrationIcon,
  SlackIntegrationIcon,
  ZapierIntegrationIcon,
} from 'src/monet/icons';
import { functionNoop } from 'src/utils/function/noop';

interface DashboardSettingsIntegrationsCardProps
  extends Pick<Integration, 'code' | 'name' | 'description' | 'enableCopy' | 'disableCopy'> {
  enabled: boolean;
  iconClassName?: string;
}

export const IntegrationIconMapper: Record<string, (props: React.ComponentProps<'svg'>) => JSX.Element> = {
  slack: SlackIntegrationIcon,
  box: BoxIntegrationIcon,
  segment: SegmentIntegrationIcon,
  zapier: ZapierIntegrationIcon,
  'google-drive': GoogleDriveIntegrationIcon,
  'hubspot-tracker': HubspotIntegrationIcon,
  hubspot: HubspotIntegrationIcon,
  'chrome-extension': GoogleChromeIntegrationIcon,
  gong: GongIntegrationIcon,
};

export const DashboardSettingsIntegrationsCard = ({
  code,
  name,
  description,
  enabled,
  enableCopy = 'Enabled',
  disableCopy = 'Connect',
  iconClassName = 'w-5 h-5',
}: DashboardSettingsIntegrationsCardProps) => {
  const IntegrationIcon = IntegrationIconMapper[code];

  return (
    <div className='flex flex-col space-y-4 text-bedrock-black text-bedrock-p w-[247px] py-0 pl-2 pr-6'>
      <div className='flex items-start space-x-2'>
        <IntegrationIcon className={iconClassName} />
        <span className='text-bedrock-p-strong'>{name}</span>
      </div>
      <span>{description}</span>
      <div className='flex items-start'>
        <Button label={enabled ? enableCopy : disableCopy} variant='secondary' size='regular' onClick={functionNoop} />
      </div>
    </div>
  );
};
